import { BASE } from '@arcxgame/contracts'
import { poll } from '@arcxmoney/arcx-react'
import { BigNumber } from 'ethers'
import React, { useEffect, useState } from 'react'
import { Saving } from 'src/services/GraphService'
import { calculateEarnings } from '../calculateEarning'
import { NumberFlippingAnimation } from '../NumberFlippingAnimation'
import './EarningSimulator.scss'

interface IProps {
  saving: Saving
  savingBalance: BigNumber
}

export function EarningSimulator({ saving, savingBalance }: IProps) {
  const [earnings, setEarnings] = useState(calculateEarnings(saving, savingBalance))

  useEffect(
    () => poll(() => setEarnings((prev) => prev.add(prev.mul(saving.savingsRate).div(BASE))), 1000),
    [saving],
  )

  useEffect(() => setEarnings(calculateEarnings(saving, savingBalance)), [saving, savingBalance])

  return (
    <h1 className="earning-simulator">
      <NumberFlippingAnimation
        numberToFlip={earnings}
        prefix="$"
        numberHeight={4}
        numberHeightLengthType="rem"
        nbDecimals={8}
      />
    </h1>
  )
}
